const ENTER_TRANSITION_DURATION_MS = 200;
const content = "_275cdqpau";
const transitionCls = "_275t13k4v8a";

export { ENTER_TRANSITION_DURATION_MS, content, transitionCls };
import "./page.styles.linaria.module.css";
//# sourceMappingURL=page.styles.js.map
